import { attr } from '@ember-data/model';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
import { Country } from '@square/dashboard-data/models/squareup/common/countries';
export default EmberDataBaseFragment.extend({
  addressLine1: attr('string'),
  // street 1
  addressLine2: attr('string'),
  // street 2
  addressLine3: attr('string'),
  addressLine4: attr('string'),
  addressLine5: attr('string'),
  locality: attr('string'),
  // city
  sublocality: attr('string'),
  sublocality1: attr('string'),
  sublocality2: attr('string'),
  sublocality3: attr('string'),
  sublocality4: attr('string'),
  sublocality5: attr('string'),
  adminLevel1: attr('string'),
  // state
  adminLevel2: attr('string'),
  adminLevel3: attr('string'),
  postalCode: attr('string'),
  // zip
  countryCode: attr('enum', {
    enumClass: Country
  }),
  sortingCode: attr('string'),
  agrexCode: attr('string')
}).reopenClass({
  _modelNameForMigration: 'squareup/common/location/address'
});